import React, { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { Col, Row, Button, Label, FormGroup, Input } from "reactstrap";
import { Form, Field } from "react-final-form";
import { useNavigate, useLocation, useParams, Link } from 'react-router-dom';
import SliderComponent from '../Authentication_usertypes/SliderComponent.js';
import { logIn } from '../../actions/AuthAction.js';

import AuthService from "./auth.service.js";
import AlertService from "../../components/Alerts/alerts.js";
import { useDispatch, useSelector } from 'react-redux';

import { ToastContainer } from 'react-toastify';
import LoadingOverlay from "react-loading-overlay-ts";
import DNALoader from "../../components/Loaders/DnaLoader.js";
import "../../assets/custom css/loadoverlay.scss";
import CopyRight from "../../components/CopyRight Bar/CopyRight.js";
import ConfigurationService from "../Configuration/configuration.service.js";
import FinanceService from "../Finance/Settings/configuration.service.js";
import bg from './bg.png';
import { fetchFCMToken } from '../../firebase/messaging.js';

const Login = () => {
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.authReducer.loading);

  useEffect(() => {
    getSetLanguage();
    setTimeout(() => {
      getFinanceConfig();
      getSystemConfig();
    }, 2000);
  }, []);

  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  // const [loading, setLoading] = useState(false);
  const [logo, setLogo] = useState(localStorage.getItem("system_logo"));
  const [system_name, setSystem_Name] = useState(localStorage.getItem("name"));
  localStorage.setItem("user_type", 'admin');

  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  function getFinanceConfig() {
    FinanceService.getConfiguration().then((response) => {
      //iph todo: 47
      //console.log("Finance API Response:-", response.data.data);
      if (response.data.status) {
        localStorage.setItem("payment_method", response.data.data[0]?.payment_method);
        localStorage.setItem("due_date", response.data.data[0]?.due_date);
        localStorage.setItem("default_notes", response.data.data[0]?.default_notes);
        localStorage.setItem("tax_percentage", response.data.data[0]?.tax_percentage);
        localStorage.setItem("currency", response.data.data[0]?.currency);
        localStorage.setItem("invoice_to", response.data.data[0]?.invoice_to);
        localStorage.setItem("invoice_to_field", response.data.data[0]?.invoice_to_field);
        localStorage.setItem("payment_types", response.data.data[0]?.payment_types);
      }
      else {
        setColors('#3ac47d', 'onerror');
      }
    },
      (error) => {
        setColors('#3ac47d', 'onerror');
      });
  }
  function getSetLanguage() {
    if (localStorage.getItem("language")) {
      const language = localStorage.getItem("language");
      i18n.changeLanguage(language);
    }
    else {
      localStorage.setItem('language', 'en');
      i18n.changeLanguage('en');
    }
  }

  function getSystemConfig() {
    ConfigurationService.getConfiguration().then((response) => {
      //iph todo: 47
      //console.log("API Response:-", response);
      if (response.data.status) {
        setColors(response.data.data[0].buttons_color, '--buttons-color');
        setColors(response.data.data[0].topbar_color, '--topbar-color');
        setColors(response.data.data[0].leftbar_color, '--leftbar-color');
        setColors(response.data.data[0].buttons_text_color, '--buttons-text-color');
        setSystemLogo(response.data.data[0].system_logo);
        setSystemName(response.data.data[0].name);
      }
      else {
        setColors('#3ac47d', 'onerror');
      }
    },
      (error) => {
        setColors('#3ac47d', 'onerror');
      });
  }

  function setColors(color, param) {
    if (param === '--buttons-color') {
      localStorage.setItem("buttons_color", color);
      document.documentElement.style.setProperty('--buttons-color', color)
    }
    if (param === '--topbar-color') {
      localStorage.setItem("topbar_color", color);
      document.documentElement.style.setProperty('--topbar-color', color)
    }
    if (param === '--leftbar-color') {
      localStorage.setItem("leftbar_color", color);
      document.documentElement.style.setProperty('--leftbar-color', color)
    }
    if (param === '--buttons-text-color') {
      localStorage.setItem("buttons_text_color", color);
      document.documentElement.style.setProperty('--buttons-text-color', color)
    }
    if (param === 'onerror') {
      localStorage.setItem("buttons_color", color);
      localStorage.setItem("topbar_color", '#fff');
      localStorage.setItem("leftbar_color", '#fff');
      localStorage.setItem("buttons_text_color", '#fff');
      document.documentElement.style.setProperty('--buttons-color', color)
      document.documentElement.style.setProperty('--topbar-color', '#fff')
      document.documentElement.style.setProperty('--leftbar-color', '#fff')
      document.documentElement.style.setProperty('--buttons-text-color', '#fff')
    }
  }

  function setSystemLogo(sys_logo) {
    setLogo(sys_logo);
    localStorage.setItem("system_logo", sys_logo);
  }
  function setSystemName(name) {
    setSystem_Name(name);
    localStorage.setItem("system_name", name);
  }
  function handlereset() {
    localStorage.setItem("reset", true)
  };

  function handleregprod() {
    localStorage.setItem("regprod", true)
  };

  const onSubmit = async values => {
    //iph todo: 47
    //console.log(values);
    // setLoading(true);
    // Always fetch a fresh FCM token at login time
    const fcm_token = await fetchFCMToken();
    var login_data = {
      functionName: "LoginUser",
      postData: {
        "email": values.email,
        "password": values.password,
        "fcm_token": fcm_token,
      },
    }
    const response = await dispatch(logIn(login_data));
    if (response.data.status === true) {
      //iph todo: 47
      //console.log("Login RES :-", response);
      // setLoading(false);
      var user_data = response.data.userData;
      user_data['username'] = user_data?.email;
      user_data['accessToken'] = user_data._id;
      user_data['session-id'] = response.data.sessionID;
      user_data['roles'] = [
        "ROLE_ADMIN",
        "ROLE_USER"
      ];
      //iph todo: 47
      //console.log("Login Response:-", response)
      localStorage.setItem("user", JSON.stringify(user_data));
      localStorage.setItem("session-id", response.data.sessionID);
      var landingpage = response?.data.userData.role_details?.landingpage
      // AlertService.successToast("Login Successful.")
      navigate("/" + landingpage);
      // window.location.reload();
    } else {
      // setLoading(false);
      AlertService.swalErrorAlert(t("Invalid Credentials or Access denied."))

    }
  };

  const validateFtn = (values) => {
    const errors = {};
    function validateEmail(email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    }
    if (!values.email) {
      errors.email = t('Email Required.');
    }
    else if (!validateEmail(values.email)) {
      errors.email = t('Please enter a valid email address.');
    }
    if (!values.password) {
      errors.password = t('Password Required.');
    }
    return errors;
  };

  return (
    <div style={styles.container}>
      <div style={styles.leftContainer}>
        <div style={styles.logoContainer}>
          <img src={logo} alt="Logo" style={styles.logo} />
        </div>
        <Form onSubmit={onSubmit} validate={validateFtn}
          render={({ handleSubmit, valid }) => (
            <form onSubmit={handleSubmit}>
              <LoadingOverlay active={loading} spinner={<DNALoader />}>
                <div className="modal-body p-5">
                  <h2 style={styles.heading}>Sign in</h2>
                  <p style={styles.logoText}>Please login to continue to your account.</p>
                  <Row form>
                    <Col md={12}>
                      <FormGroup>
                        <Field name="email">
                          {({ input, meta }) => (
                            <div className="mb-3">
                              <Label for="email">{t('Email')}</Label>
                              <Input {...input} type="email" invalid={meta.error && meta.touched} placeholder={t('Enter Email')} />
                              {meta.error && meta.touched && <span className="text-danger">{meta.error}</span>}
                            </div>
                          )}
                        </Field>
                      </FormGroup>
                    </Col>
                    <Col md={12}>
                      <FormGroup>
                        <Field name="password">
                          {({ input, meta }) => (
                            <div className="mb-3">
                              <Label for="password">{t('Password')}</Label>
                              <Input {...input} type="password" invalid={meta.error && meta.touched} placeholder="**********" />
                              {meta.error && meta.touched && <span className="text-danger">{meta.error}</span>}
                            </div>
                          )}
                        </Field>
                      </FormGroup>
                    </Col>
                  </Row>
                  <FormGroup check className="mb-3">
                    <div style={styles.formFooter}>
                      <div style={styles.rememberMe}>
                        {/* <Input type="checkbox" id="rememberMe" />
                        <label htmlFor="rememberMe" style={styles.checkboxLabel}>Keep me logged in</label> */}
                      </div>
                      <a href="/forgot-password" style={styles.forgotPassword}>Forgot Password?</a>
                    </div>
                  </FormGroup>
                  <div className="d-grid mb-3">
                    <Button size="lg" className="btn-custom-color" type="submit" disabled={!valid}>
                      {t('Login')}
                    </Button>
                  </div>
                  {/* <div className="text-center">
                    Don't Have an Account?
                    <a href={`/register_client/`} style={{
                      color: '#007bff',
                      textDecoration: 'none',
                      alignContent: 'center',
                    }}>Create New</a>
                  </div> */}
                </div>
              </LoadingOverlay>
            </form>
          )}
        />
        {/* <CopyRight /> */}
      </div>
      <div style={styles.rightContainer}>
        {/* <SliderComponent /> */}
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    height: '100vh',
  },
  leftContainer: {
    flex: 1, // The left container will take up 1 part of the available space
    display: 'flex',
    marginTop: '3%',
    flexDirection: 'column',
    background: 'white',
    padding: '0 60px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
  },
  rightContainer: {
    flex: 2, // The right container will take up 2 parts of the available space
    backgroundImage: `url(${bg})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    position: 'relative',
  },
  overlayText: {
    position: 'absolute',
    top: '1%',
    left: '10%',
    color: 'white',
    textAlign: 'left',
    padding: '20px',
    backgroundColor: 'rgba(72, 132, 194, 0.5)',
  },
  logoContainer: {
    marginBottom: '20px',
  },
  logo: {
    width: '180px', 
    height: 'auto',
  },
  heading: {
    marginTop: '12%',
    fontSize: '28px',
    fontWeight: 'bold',
    marginBottom: '10px',
  },
  logoText: {
    fontSize: '16px',
    color: '#666',
    marginBottom: '20px',
  },
  formFooter: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  rememberMe: {
    display: 'flex',
    alignItems: 'center',
  },
  checkboxLabel: {
    marginLeft: '5px',
  },
  forgotPassword: {
    color: '#007bff',
    textDecoration: 'none',
  },
};

export default Login